import { Space } from 'antd';
import { useContext, useMemo, useCallback } from 'react';

import { VISITS_FILTER } from '@app/constants';
import { useMemoizeObject } from '@app/hooks';
import { CHF_VISITS_FILTER } from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

type Props = { filterGroupIndex: number };

export const VisitsTagsLabel = ({ filterGroupIndex }: Props) => {
  const {
    filters,
    serverFilters,
    memoizedServerFilters,
    setFilters,
    setServerFilters,
  } = useContext(ClientFiltersContext);

  const memoized = useMemoizeObject(memoizedServerFilters);

  const tagIds = useMemo(() => {
    return (
      memoized?.[CHF_VISITS_FILTER]?.[filterGroupIndex]?.Values?.[0]?.TagIds ??
      []
    );
  }, [memoized, filterGroupIndex]);

  const isIncluded = useMemo(() => {
    // Определяем, включены ли теги для этой группы фильтров
    return (
      memoized?.[CHF_VISITS_FILTER]?.[filterGroupIndex]?.IsInclude ?? false
    );
  }, [memoized, filterGroupIndex]);

  const clearTags = useCallback(() => {
    setFilters((prev) => {
      const nextVisits = prev.VisitsFilter.map((unit, index) => {
        if (index !== filterGroupIndex) return unit;
        return {
          ...unit,
          Values: [
            {
              ...unit.Values?.[0],
              TagIds: null,
            },
          ],
        };
      });

      return { ...prev, VisitsFilter: nextVisits };
    });

    setServerFilters((prev) => {
      const nextVisits = prev.VisitsFilter.map((unit, index) => {
        if (index !== filterGroupIndex) return unit;
        return {
          ...unit,
          Values: [
            {
              ...unit.Values?.[0],
              TagIds: null,
            },
          ],
        };
      });

      return { ...prev, VisitsFilter: nextVisits };
    });
  }, [filterGroupIndex, setFilters, setServerFilters]);

  return (
    <Space className="visits-tags-label" direction="vertical">
      <span>Теги записи</span>

      {tagIds.length > 0 && (
        <ClientFilterTag
          filters={filters}
          serverFilters={serverFilters}
          filtersArea={VISITS_FILTER}
          filterGroupIndex={filterGroupIndex}
          setFilters={setFilters}
          setServerFilters={setServerFilters}
          valueKey={'TagIds'}
          handleTagDeletion={clearTags}
        >
          <>
            {isIncluded ? 'Включено' : 'Исключено'}: {`${tagIds.length}`}
          </>
        </ClientFilterTag>
      )}
    </Space>
  );
};
